"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var utils_1 = require("../../../../utils/utils");
var Button_1 = __importDefault(require("../../../Button/Button"));
var DeleteComps_1 = require("../DeleteComps");
var DropDownMenu_1 = __importDefault(require("../DropDownMenu"));
var PrestupekWrap = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: 22px;\n  ", "\n"], ["\n  line-height: 22px;\n  ",
    "\n"])), function (_a) {
    var $isModal = _a.$isModal;
    return $isModal && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p {\n        margin-bottom: 0;\n      }\n    "], ["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p {\n        margin-bottom: 0;\n      }\n    "])));
});
var PrestupekHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 15px;\n  font-weight: bold;\n  color: #fe505d;\n  margin-bottom: 5px;\n"], ["\n  font-size: 15px;\n  font-weight: bold;\n  color: #fe505d;\n  margin-bottom: 5px;\n"])));
var PrestupekSubHeader = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 13px;\n  color: #484f56;\n  font-weight: bold;\n"], ["\n  font-size: 13px;\n  color: #484f56;\n  font-weight: bold;\n"])));
var PoznamkaDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  word-wrap: break-word;\n  font-size: 15px;\n  margin-top: 5px;\n  color: #333333;\n"], ["\n  word-wrap: break-word;\n  font-size: 15px;\n  margin-top: 5px;\n  color: #333333;\n"])));
var DetailPrestupek = function (_a) {
    var _b;
    var prestupek = _a.prestupek, isModal = _a.isModal, handleEdit = _a.handleEdit, prestupekTypy = _a.prestupekTypy, handleSmazat = _a.handleSmazat;
    var showDeleteDialog = hooks_1.useBoolean(false);
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current && showDeleteDialog.value) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [showDeleteDialog.value]);
    var getDeleteMessage = function () {
        var _a, _b;
        return (react_1.default.createElement("div", null,
            "P\u0159estupek ",
            react_1.default.createElement("strong", null, (_b = (_a = prestupek.typyPrestupku) === null || _a === void 0 ? void 0 : _a.map(function (p) { var _a; return (_a = prestupekTypy === null || prestupekTypy === void 0 ? void 0 : prestupekTypy.find(function (t) { return t.id === p.id; })) === null || _a === void 0 ? void 0 : _a.nazev; })) === null || _b === void 0 ? void 0 : _b.join(', ')),
            " ze dne",
            ' ',
            utils_1.formatDate(prestupek.nabytiPravniMoci),
            " byl \u00FAsp\u011B\u0161n\u011B smaz\u00E1n."));
    };
    return (react_1.default.createElement(PrestupekWrap, { "$isModal": isModal },
        isModal && react_1.default.createElement(DropDownMenu_1.default, { handleEdit: handleEdit, handleDelete: showDeleteDialog.setTrue, id: prestupek.id }),
        react_1.default.createElement(PrestupekHeader, null, (_b = prestupek.typyPrestupku) === null || _b === void 0 ? void 0 : _b.map(function (p) { return p.nazev; }).join(', ')),
        prestupek.nabytiPravniMoci && react_1.default.createElement(PrestupekSubHeader, null,
            "Pr\u00E1vn\u00ED moc: ",
            utils_1.formatDate(prestupek.nabytiPravniMoci)),
        prestupek.spravniTrest && react_1.default.createElement(PrestupekSubHeader, null,
            "Pokuta: ",
            prestupek.spravniTrest,
            " K\u010D"),
        react_1.default.createElement(PoznamkaDiv, { ref: ref }, prestupek.poznamka),
        !isModal && react_1.default.createElement("br", null),
        showDeleteDialog.value && (react_1.default.createElement(DeleteComps_1.DeleteDialog, { id: "deleteDialog" + prestupek.id },
            react_1.default.createElement(DeleteComps_1.DeleteDialogText, null, "Opravdu chcete tento p\u0159estupek smazat?"),
            react_1.default.createElement(DeleteComps_1.DeleteButtonsWrap, null,
                react_1.default.createElement(Button_1.default, { type: "button", primary: false, onClick: showDeleteDialog.setFalse, name: "Zachovat" }, "NE, ZACHOVAT"),
                react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: function () { return handleSmazat(prestupek.id, getDeleteMessage()); }, name: "Smazat" }, "ANO, SMAZAT"))))));
};
DetailPrestupek.defaultProps = {
    isModal: false,
    prestupekTypy: [],
};
exports.default = DetailPrestupek;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
